import { gql } from '@apollo/client';

const UpdateExtension = gql`
  mutation UpdateExtension($input: UpdateExtensionInput!) {
    devhub {
      admin {
        updateExtension(input: $input) {
          success
          message
          extension {
            id
            name
            owner
            extensionType
            distributionList
            slackChannel
            notes
            securityCredentialsUrl
          }
        }
      }
    }
  }
`;

export default UpdateExtension;
